// Cricket Statistics and Records (Mock Data - Can be replaced with API)

export const formatInfo = {
  test: {
    name: "Test Cricket",
    duration: "5 days (unlimited overs)",
    balls: "6 balls per over",
    description: "The longest and most traditional format. Two innings per team.",
    firstMatch: "1877 (Australia vs England)",
    icon: "🏏"
  },
  odi: {
    name: "One Day International (ODI)",
    duration: "50 overs per side",
    balls: "300 balls per innings",
    description: "Limited-overs format with colored clothing. One innings per team.",
    firstMatch: "1971 (Australia vs England)",
    icon: "🎯"
  },
  t20i: {
    name: "Twenty20 International (T20I)",
    duration: "20 overs per side",
    balls: "120 balls per innings",
    description: "Shortest international format. Fast-paced, high-scoring games.",
    firstMatch: "2005 (Australia vs New Zealand)",
    icon: "⚡"
  }
};

export const iccRankings = {
  lastUpdated: "December 2024",
  test: {
    teams: [
      { rank: 1, team: "India", rating: 121, flag: "🇮🇳" },
      { rank: 2, team: "Australia", rating: 116, flag: "🇦🇺" },
      { rank: 3, team: "England", rating: 105, flag: "🏴󠁧󠁢󠁥󠁮󠁧󠁿" },
      { rank: 4, team: "South Africa", rating: 101, flag: "🇿🇦" },
      { rank: 5, team: "New Zealand", rating: 98, flag: "🇳🇿" },
      { rank: 6, team: "Sri Lanka", rating: 86, flag: "🇱🇰" },
      { rank: 7, team: "Pakistan", rating: 82, flag: "🇵🇰" },
      { rank: 8, team: "West Indies", rating: 76, flag: "🌴" },
      { rank: 9, team: "Bangladesh", rating: 68, flag: "🇧🇩" }
    ],
    batsmen: [
      { rank: 1, name: "Joe Root", team: "England", rating: 882 },
      { rank: 2, name: "Kane Williamson", team: "New Zealand", rating: 867 },
      { rank: 3, name: "Marnus Labuschagne", team: "Australia", rating: 855 },
      { rank: 4, name: "Steve Smith", team: "Australia", rating: 845 },
      { rank: 5, name: "Babar Azam", team: "Pakistan", rating: 832 }
    ],
    bowlers: [
      { rank: 1, name: "Jasprit Bumrah", team: "India", rating: 892 },
      { rank: 2, name: "Pat Cummins", team: "Australia", rating: 855 },
      { rank: 3, name: "Kagiso Rabada", team: "South Africa", rating: 841 },
      { rank: 4, name: "Josh Hazlewood", team: "Australia", rating: 832 },
      { rank: 5, name: "Ravichandran Ashwin", team: "India", rating: 825 }
    ]
  },
  odi: {
    teams: [
      { rank: 1, team: "India", rating: 118, flag: "🇮🇳" },
      { rank: 2, team: "Australia", rating: 112, flag: "🇦🇺" },
      { rank: 3, team: "South Africa", rating: 108, flag: "🇿🇦" },
      { rank: 4, team: "England", rating: 101, flag: "🏴󠁧󠁢󠁥󠁮󠁧󠁿" },
      { rank: 5, team: "New Zealand", rating: 99, flag: "🇳🇿" }
    ],
    batsmen: [
      { rank: 1, name: "Babar Azam", team: "Pakistan", rating: 865 },
      { rank: 2, name: "Virat Kohli", team: "India", rating: 852 },
      { rank: 3, name: "Rohit Sharma", team: "India", rating: 838 },
      { rank: 4, name: "Quinton de Kock", team: "South Africa", rating: 821 },
      { rank: 5, name: "Shubman Gill", team: "India", rating: 815 }
    ],
    bowlers: [
      { rank: 1, name: "Mohammed Shami", team: "India", rating: 725 },
      { rank: 2, name: "Josh Hazlewood", team: "Australia", rating: 718 },
      { rank: 3, name: "Shaheen Afridi", team: "Pakistan", rating: 712 },
      { rank: 4, name: "Trent Boult", team: "New Zealand", rating: 698 },
      { rank: 5, name: "Mitchell Starc", team: "Australia", rating: 692 }
    ]
  },
  t20i: {
    teams: [
      { rank: 1, team: "India", rating: 267, flag: "🇮🇳" },
      { rank: 2, team: "England", rating: 261, flag: "🏴󠁧󠁢󠁥󠁮󠁧󠁿" },
      { rank: 3, team: "Australia", rating: 255, flag: "🇦🇺" },
      { rank: 4, team: "South Africa", rating: 251, flag: "🇿🇦" },
      { rank: 5, team: "West Indies", rating: 247, flag: "🌴" }
    ],
    batsmen: [
      { rank: 1, name: "Suryakumar Yadav", team: "India", rating: 892 },
      { rank: 2, name: "Phil Salt", team: "England", rating: 825 },
      { rank: 3, name: "Travis Head", team: "Australia", rating: 815 },
      { rank: 4, name: "Babar Azam", team: "Pakistan", rating: 788 },
      { rank: 5, name: "Mohammad Rizwan", team: "Pakistan", rating: 776 }
    ],
    bowlers: [
      { rank: 1, name: "Adil Rashid", team: "England", rating: 701 },
      { rank: 2, name: "Rashid Khan", team: "Afghanistan", rating: 695 },
      { rank: 3, name: "Wanindu Hasaranga", team: "Sri Lanka", rating: 688 },
      { rank: 4, name: "Akeal Hosein", team: "West Indies", rating: 678 },
      { rank: 5, name: "Arshdeep Singh", team: "India", rating: 665 }
    ]
  }
};

export const allTimeRecords = {
  test: {
    batting: [
      { record: "Most Runs", holder: "Sachin Tendulkar (India)", value: "15,921 runs" },
      { record: "Highest Score", holder: "Brian Lara (West Indies)", value: "400* vs England" },
      { record: "Most Centuries", holder: "Sachin Tendulkar (India)", value: "51 centuries" },
      { record: "Highest Average (5000+ runs)", holder: "Don Bradman (Australia)", value: "99.94" },
      { record: "Most Double Centuries", holder: "Don Bradman (Australia)", value: "12 double tons" }
    ],
    bowling: [
      { record: "Most Wickets", holder: "Muttiah Muralitharan (Sri Lanka)", value: "800 wickets" },
      { record: "Best Innings Figures", holder: "Jim Laker (England)", value: "10/53 vs Australia" },
      { record: "Best Match Figures", holder: "Jim Laker (England)", value: "19/90 vs Australia" },
      { record: "Most 5-Wicket Hauls", holder: "Muttiah Muralitharan (Sri Lanka)", value: "67" },
      { record: "Most 10-Wicket Matches", holder: "Muttiah Muralitharan (Sri Lanka)", value: "22" }
    ]
  },
  odi: {
    batting: [
      { record: "Most Runs", holder: "Sachin Tendulkar (India)", value: "18,426 runs" },
      { record: "Highest Score", holder: "Rohit Sharma (India)", value: "264 vs Sri Lanka" },
      { record: "Most Centuries", holder: "Sachin Tendulkar (India)", value: "49 centuries" },
      { record: "Fastest Century", holder: "AB de Villiers (South Africa)", value: "31 balls" },
      { record: "Most Runs in a Calendar Year", holder: "Sachin Tendulkar (India)", value: "1,894 (1998)" }
    ],
    bowling: [
      { record: "Most Wickets", holder: "Muttiah Muralitharan (Sri Lanka)", value: "534 wickets" },
      { record: "Best Figures", holder: "Chaminda Vaas (Sri Lanka)", value: "8/19 vs Zimbabwe" },
      { record: "Most 5-Wicket Hauls", holder: "Muttiah Muralitharan (Sri Lanka)", value: "10" },
      { record: "Best Economy (100+ matches)", holder: "Joel Garner (West Indies)", value: "3.09" },
      { record: "Most Wickets in World Cup", holder: "Glenn McGrath (Australia)", value: "71" }
    ]
  },
  t20i: {
    batting: [
      { record: "Most Runs", holder: "Virat Kohli (India)", value: "4,000+ runs" },
      { record: "Highest Score", holder: "Hazratullah Zazai (Afghanistan)", value: "162* vs Ireland" },
      { record: "Most Centuries", holder: "Rohit Sharma (India)", value: "4 centuries" },
      { record: "Highest Strike Rate (1000+ runs)", holder: "Suryakumar Yadav (India)", value: "170+" },
      { record: "Most Sixes", holder: "Rohit Sharma (India)", value: "200+" }
    ],
    bowling: [
      { record: "Most Wickets", holder: "Tim Southee (New Zealand)", value: "130+ wickets" },
      { record: "Best Figures", holder: "Deepak Chahar (India)", value: "6/7 vs Bangladesh" },
      { record: "Best Economy (20+ matches)", holder: "Rashid Khan (Afghanistan)", value: "6.2" },
      { record: "Most 4-Wicket Hauls", holder: "Rashid Khan (Afghanistan)", value: "5" },
      { record: "Most Maidens", holder: "Tim Southee (New Zealand)", value: "5" }
    ]
  }
};

export const upcomingEvents = [
  {
    name: "ICC Champions Trophy 2025",
    date: "February 2025",
    venue: "Pakistan & UAE",
    teams: 8,
    format: "ODI"
  },
  {
    name: "IPL 2025",
    date: "March - May 2025",
    venue: "India",
    teams: 10,
    format: "T20"
  },
  {
    name: "ICC T20 World Cup 2026",
    date: "February 2026",
    venue: "India & Sri Lanka",
    teams: 20,
    format: "T20I"
  },
  {
    name: "ICC Cricket World Cup 2027",
    date: "October 2027",
    venue: "South Africa, Zimbabwe, Namibia",
    teams: 14,
    format: "ODI"
  }
];
